import React from 'react';
import ReactDOM from 'react-dom';

import * as serviceWorker from './serviceWorker';
import './env.config'
import App from './App';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

const renderApp = Component => {
  ReactDOM.render(
    <GoogleReCaptchaProvider
      reCaptchaKey="6LcTJsInAAAAAJHJ3PNbLoPvx1tCP__3T8L11X9s"
    >
      <Component />
    </GoogleReCaptchaProvider>,
    document.getElementById('root')
  );
};

renderApp(App);

if (module.hot) {
  module.hot.accept('./App', () => {
    const NextApp = require('./App').default
    renderApp(NextApp)
  })
}

serviceWorker.unregister();
